import firestore from './firestore'
import state from './state'
import getters from './getters'


export default {
  ...firestore,
  state,
  getters
}